export class AssetUrlsController {
  setMap(map) {
    this._map = map;
  }
  remapedUrl(url) {
    if (!this._map) {
      return;
    }
    const elements = url.split("?");
    const preQuery = elements[0];
    const query = elements[1];
    const remapedUrl = this._map[preQuery];
    if (remapedUrl) {
      if (query) {
        return `${remapedUrl}?${query}`;
      } else {
        return remapedUrl;
      }
    }
  }
}
